//PMC
import Home from "@/app/pmc/home/home.page";
import Properties from "@/app/pmc/properties/properties.page";
import PropertyDetail from "@/app/pmc/properties-detail/properties-detail.page";
import VendorList from "@/app/pmc/vendors/vendors.page.tsx";
import VendorDetail from "@/app/pmc/vendors/vendors.detail/vendor-detail.page.tsx";
import AppointmentList from "@/app/pmc/appointments/appointments.page";
import AppointmentCalendarPage from "@/app/pmc/appointments/calendar.page";
import AppointmentDetailPage from "@/app/pmc/appointments/appointment-detail.page.tsx";
import CustomerInvoicesPage from "@/app/pmc/invoices/invoices.page";
import CustomerInvoiceDetailPage from "@/app/pmc/invoices/invoice-detail.page";
import { OrganizationAdminsOnly } from "@/components/shared/auth/organization-admins-only";

export const pmc_routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/properties",
    element: <Properties />,
  },
  {
    path: "/properties/:propertyId",
    element: <PropertyDetail />,
  },
  {
    path: "/vendors",
    element: <VendorList />,
  },
  {
    path: "/vendors/:vendorId",
    element: <VendorDetail />,
  },
  {
    path: "/appointments",
    element: <AppointmentList />,
  },
  {
    path: "/appointments/calendar",
    element: <AppointmentCalendarPage />,
  },
  {
    path: "/appointments/:appointmentId",
    element: <AppointmentDetailPage />,
  },
  {
    path: "/invoices",
    element: (
      <OrganizationAdminsOnly>
        <CustomerInvoicesPage />
      </OrganizationAdminsOnly>
    ),
  },
  {
    path: "/invoices/:invoiceId",
    element: (
      <OrganizationAdminsOnly>
        <CustomerInvoiceDetailPage />
      </OrganizationAdminsOnly>
    ),
  },
];
